import { Injectable } from '@angular/core';
import { SHA256 } from 'crypto-es/lib/sha256';

@Injectable({
  providedIn

:

 'root'
})


/**
 * A Proof of Work (PoW) challenge is a computational puzzle that requires a certain amount of effort to solve. 
 * The goal is to find a value that produces a hash meeting certain criteria (starts with "0000").
 * It provides a mechanism to deter automated attacks by
 * a) requiring computational effort to solve a challenge
 * b) need to develop custom scripts or code to handle the proof-of-work challenge, increasing the effort and cost
 */
export class ProofOfWorkService {

  constructor() { }

  runProofOfWorkChallenge(nonce: string, email: string): string {
    let hash = "";
    let counter = 0;
    while (!hash.startsWith("0000")) {
      hash = SHA256(`${email}${nonce}${++counter}`).toString();
    }

    return `${hash}#${counter}`;
  }
}